import { getUrl } from '@buffer-mono/shared-utils/bibe'

export function getSettingsUrl(): string {
  return getUrl('https://publish.buffer.com/settings/billing')
}
